module.exports = __webpack_public_path__ + "img/French Southern Territories.f10ea716.svg";